// import VueClickAway from 'vue3-click-away'
import { defineNuxtPlugin } from '#app';
import { directive } from 'vue3-click-away';

export default defineNuxtPlugin((nuxtApp) => {
  // nuxtApp.vueApp.use()
  nuxtApp.vueApp.directive('click-away', directive);
});
